import type { ItemDef, ItemId } from '../core/types';
import type { Rng } from '../core/rng';
import { clamp } from '../core/math';

/**
 * A 6 magyar vicctárgy. A sorrend számít: a rulett és a HUD ebben a sorrendben járja be őket.
 * A színek/ikonok a HUD-ra mennek, a blurb a tárgyleírás.
 */

const TURBO: ItemDef = {
  id: 'turbo',
  name: 'Turbó gáz',
  icon: '»',
  color: '#ffc857',
  kind: 'self',
  blurb: 'Azonnali gyorsítás 1.6 mp-ig.',
  comeBack: true,
};

const OIL: ItemDef = {
  id: 'oil',
  name: 'Olajfolt',
  icon: '●',
  color: '#3a3f4b',
  kind: 'drop',
  blurb: 'Magad mögé csöpögtetett csúszós folt; aki ráhajt, kipördül.',
};

const SODA: ItemDef = {
  id: 'soda',
  name: 'Szódásüveg',
  icon: '↗',
  color: '#8fd14f',
  kind: 'projectile',
  blurb: 'Előredobott rakéta; az első találatot kipördíti.',
  comeBack: true,
};

const LIGHTNING: ItemDef = {
  id: 'lightning',
  name: 'Villámcsapás',
  icon: '↯',
  color: '#ffe066',
  kind: 'global',
  blurb: 'Mindenki más lelassul 2.2 mp-re.',
  comeBack: true,
};

const SHIELD: ItemDef = {
  id: 'shield',
  name: 'Bevásárlószatyor',
  icon: '◈',
  color: '#3ec6c0',
  kind: 'self',
  blurb: '5 mp védettség a találatok ellen.',
  comeBack: true,
};

const GLUE: ItemDef = {
  id: 'glue',
  name: 'Pattex csapda',
  icon: '▲',
  color: '#f28f3b',
  kind: 'drop',
  blurb: 'Lerakott ragacs: aki ráhajt, 2.2 mp-re lelassul.',
};

export const ITEMS: ItemDef[] = [TURBO, OIL, SODA, LIGHTNING, SHIELD, GLUE];

export const ITEM_BY_ID: Record<ItemId, ItemDef> = {
  turbo: TURBO,
  oil: OIL,
  soda: SODA,
  lightning: LIGHTNING,
  shield: SHIELD,
  glue: GLUE,
};

/**
 * Súlyok [élen, hátul]. Az élen állók akadályozó tárgyat kapnak,
 * a hátul lévők felzárkóztatót (turbo / pajzs / villám).
 * Az oszlopok összege ~100, hogy a súlyok olvashatóak legyenek.
 */
const WEIGHTS: Record<ItemId, readonly [number, number]> = {
  turbo: [6, 30],
  oil: [30, 6],
  soda: [26, 14],
  lightning: [2, 18],
  shield: [10, 26],
  glue: [26, 8],
};

/**
 * Pozíció szerinti sorsolás: 0 = első hely, 1 = utolsó.
 * Determinisztikus: pontosan egy értéket fogyaszt a kapott rng-ből.
 */
export function rollItemId(positionRatio: number, rng: Rng): ItemId {
  const t = Number.isFinite(positionRatio) ? clamp(positionRatio, 0, 1) : 0.5;
  return rng
    .weighted(ITEMS, (item) => {
      const [front, back] = WEIGHTS[item.id];
      return front + (back - front) * t;
    })
    .id;
}
